module.exports = __webpack_public_path__ + "mp.54a9763112f1cc43f4ee.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/mp.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/mp.svg
// module chunks = styles